// extracted by mini-css-extract-plugin
module.exports = {"note":"ProductSelection-module-note-1Cz","header":"ProductSelection-module-header-1__","pricing":"ProductSelection-module-pricing-2Ge"};